import { register } from 'swiper/element/bundle'

import anchor from './components/anchor'
import cursorShift from './components/cursorShift'
import draggableInit from './components/DraggableInit'
import form from './components/form'
import modal from './components/modal'
import nav from './components/nav'
import pageRunners from './pages'
import { responsiveHeaderHeight } from './utils/headerHeight'
import { initSmoothScrolling } from './utils/smoothScroll'

export let lenis

window.addEventListener('DOMContentLoaded', () => {
    responsiveHeaderHeight()
    lenis = initSmoothScrolling()

    // pages
    pageRunners()

    // components
    requestAnimationFrame(() => {
        cursorShift()
        anchor()
        nav()
        form()
        draggableInit()
        modal()
    })

    const swiperElements = document.querySelectorAll('swiper-container')
    if (swiperElements.length) {
        register()
    }
})
